/**
 * Client Component에서도 안전하게 사용할 수 있는 compile-time public env.
 * 공개 origin 검증은 Zod가 client bundle로 유입되지 않도록 env.server.ts에서 수행한다.
 */
export const isDev = process.env.NODE_ENV === 'development'

/**
 * 백엔드 세션·CSRF 쿠키 이름. Django 기본값은 sessionid·csrftoken 이고,
 * 백엔드가 이름을 바꿔 쓰면(SESSION_COOKIE_NAME·CSRF_COOKIE_NAME) 여기에 같은 값을 넣는다.
 * client http 는 CSRF 쿠키를 읽어 X-CSRFToken 헤더로, session server http 는 두 쿠키를 백엔드로 넘긴다.
 */
export const csrfCookieName =
  process.env.NEXT_PUBLIC_CSRF_COOKIE_NAME?.trim() || 'veluvit_csrftoken'
export const sessionCookieName =
  process.env.NEXT_PUBLIC_SESSION_COOKIE_NAME?.trim() || 'veluvit_sessionid'

/** 백엔드 공개 주소의 host(없거나 잘못되면 빈 문자열) — 클라이언트가 백엔드 도메인을 알아야 할 때(간편 로그인 이동 주소 검증) */
export const publicApiHost = (() => {
  try {
    return process.env.NEXT_PUBLIC_API_URL
      ? new URL(process.env.NEXT_PUBLIC_API_URL).host
      : ''
  } catch {
    return ''
  }
})()

export const webVitalsEndpoint = parseOptionalSameOriginPath(
  process.env.NEXT_PUBLIC_WEB_VITALS_ENDPOINT,
  'NEXT_PUBLIC_WEB_VITALS_ENDPOINT'
)

export function parseOptionalSameOriginPath(
  value: string | undefined,
  name: string
): string | undefined {
  const candidate = value?.trim()
  if (!candidate) {
    return undefined
  }

  const baseUrl = 'https://app.local'
  let parsedUrl: URL
  try {
    parsedUrl = new URL(candidate, baseUrl)
  } catch {
    throw new Error(`${name}에는 hash가 없는 same-origin 경로를 입력해 주세요.`)
  }

  if (
    !candidate.startsWith('/') ||
    candidate.startsWith('//') ||
    parsedUrl.origin !== baseUrl ||
    parsedUrl.hash
  ) {
    throw new Error(`${name}에는 hash가 없는 same-origin 경로를 입력해 주세요.`)
  }

  return `${parsedUrl.pathname}${parsedUrl.search}`
}
